/** True for a click that should be intercepted to open the citation panel: a plain left click with
 * no modifier key held. Ctrl/Cmd/Shift/Alt+click and middle-click keep the browser's native
 * open-in-new-tab/background-tab behavior on the citation's real href, so the link still works like
 * any other link even though a plain click is redirected to the panel. */
export function isPlainLeftClick(event: MouseEvent): boolean {
  return event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;
}
